var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentName,{tag:"component",attrs:{"scopeObj":_vm.scopeObj,"row":_vm.row,"column":_vm.column},on:{"editCell":_vm.editCell}})}
var staticRenderFns = []

export { render, staticRenderFns }